import { observer } from 'mobx-react';
import { useRef } from 'react';
import ParticipantsStore from '../../../../../ParticipantsStore';
import Display from './Display';
import OpenModalButton from './OpenModalButton';
import Reactions from './Reactions';
import { AddLicenseToParticipantsStore } from './Store';
import ParticipantStore from '../../../../../ParticipantStore';

interface Props {
  participantsStore: ParticipantsStore;
  checkedParticipants: ParticipantStore[];
}

function AddLicenseToParticipants({ participantsStore, checkedParticipants }: Props) {
  const licenseAllocationsStore = useRef(new AddLicenseToParticipantsStore()).current;

  return (
    <>
      <OpenModalButton
        loading={licenseAllocationsStore.loading}
        participantsStore={participantsStore}
      />
      <Display
        licenseAllocationsStore={licenseAllocationsStore}
        checkedParticipants={checkedParticipants}
        participantsStore={participantsStore}
      />
      <Reactions store={licenseAllocationsStore} fireImmediately />
    </>
  );
}

export default observer(AddLicenseToParticipants);
